var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTwitterCircle = function SvgTwitterCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40",
    width: 41,
    height: 41
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 40a20 20 0 1120-20 20 20 0 01-20 20zm0-39a19 19 0 1019 19A19 19 0 0020 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.5 14.36a7.79 7.79 0 01-2.23.57 3.87 3.87 0 001.73-2.1 8 8 0 01-2.46.89 3.85 3.85 0 00-6.71 2.52 3.28 3.28 0 00.08.88A11 11 0 0112 13a3.86 3.86 0 001.1 5.16 3.87 3.87 0 01-1.73-.51v.05a3.85 3.85 0 003 3.84 4.27 4.27 0 01-1 .12 4.41 4.41 0 01-.73-.09 3.87 3.87 0 003.56 2.74 7.78 7.78 0 01-4.82 1.57c-.31 0-.62 0-.92-.07a11 11 0 0017-8.94 4.17 4.17 0 000-.5 7.61 7.61 0 002-2"
  })));
};
export default SvgTwitterCircle;